<div class="sz-week-strip">
  @for (day of days(); track $index) {
    <div
      class="sz-week-strip__day"
      [class.sz-week-strip__day--on]="day.state === 'on'"
      [class.sz-week-strip__day--today]="day.state === 'today'">
      <span class="sz-week-strip__dot" aria-hidden="true"></span>
      <span class="sz-week-strip__label">{{ day.label }}</span>
    </div>
  }
</div>
